import api from "./axios";

export const login = (identifier, password) =>
  api.post("/auth/login", { identifier, password });

export const logout = () => api.post("/auth/logout");

export const refreshToken = () => api.post("/auth/refresh");

export const getMe = () => api.get("/auth/me");

export const updateProfile = (data) => api.put("/auth/me", data);

export const changePassword = (current_password, new_password) =>
  api.post("/auth/change-password", { current_password, new_password });

export const forgotPassword = (email) =>
  api.post("/auth/forgot-password", { email });

export const resetPassword = (email, otp, new_password) =>
  api.post("/auth/reset-password", { email, otp, new_password });
